export default __webpack_public_path__ + "static/media/react.250ec953.jpg";